import { AnalyticsBrowser } from "@segment/analytics-next";
import firebase from "firebase/compat/app";
import React from "react";
import TagManager from "react-gtm-module";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "styled-components";

import AuthLoadingWrapper from "~/components/AuthLoadingWrapper";
import AuthWrapper from "~/components/AuthWrapper";
import themeSettings from "~/components/base/settings";
import Routes from "~/components/Routes";
import config from "~/config";
import useScrollbarWidth from "~/hooks/useScrollbarWidth";

import "~/assets/stylesheets/application.css";

import { FirebaseAuthProvider } from "~/context/FirebaseAuthContext";

const tagManagerArgs = {
  gtmId: process.env.REACT_APP_GTM_CONTAINER_ID,
};

TagManager.initialize(tagManagerArgs);

export const analytics = AnalyticsBrowser.load({
  writeKey: process.env.REACT_APP_SEGMENT_WRITE_KEY,
});

if (!firebase.apps.length) {
  firebase.initializeApp(config);
}

export default function App() {
  useScrollbarWidth();

  return (
    <ThemeProvider theme={themeSettings}>
      <BrowserRouter>
        <AuthWrapper>
          <FirebaseAuthProvider>
            <AuthLoadingWrapper>
              <Routes />
            </AuthLoadingWrapper>
          </FirebaseAuthProvider>
        </AuthWrapper>
      </BrowserRouter>
    </ThemeProvider>
  );
}
